import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import YouTube from "react-youtube";
import calculateAspectRatioPaddingTopPercentage from "utils/calculateAspectRatioPaddingTopPercentage";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => {
    const youtubeAspectRatioPercentage = calculateAspectRatioPaddingTopPercentage({
        height: 9,
        width: 16,
    });

    return createStyles({
        root: {
            position: "relative",
            paddingBottom: youtubeAspectRatioPercentage,
        },
        videoContainer: {
            "& iframe": {
                width: "100%",
                height: "100%",
                position: "absolute",
            },
        },
    });
});

export interface IYouTubeVideoProps extends HTMLAttributes<HTMLDivElement> {
    videoId: string;
}

export default function YouTubeVideo(props: IYouTubeVideoProps) {
    const { videoId, className, ...rest } = props;
    const classes = useStyles();

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            <div className={classes.videoContainer}>
                <YouTube
                    videoId={videoId}
                    opts={{
                        playerVars: {
                            // https://developers.google.com/youtube/player_parameters
                            controls: 1,
                            fs: 1,
                            modestbranding: 1,
                            autoplay: 1,
                        },
                    }}
                />
            </div>
        </div>
    );
}
